import { createSlice } from "@reduxjs/toolkit";

export const userDetailsSlice = createSlice({
  name: "userData",
  initialState: {
    data: null
  },
  reducers: {
    addUserData: (state, action) => {
        state.data = action.payload;
    },
}
});

export const { addUserData } = userDetailsSlice.actions;
export default userDetailsSlice.reducer;